import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const rancher = defineConnector({
  identifier: "rancher",
  name: "Rancher",
  tagLine: "Kubernetes management platform",
  logo,
  protocol: "http",
  tags: ["it", "engineering"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.rancher\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Rancher instance, click your profile icon, select **Account & API Keys**, and create a new API key.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Rancher host",
          placeholder: "rancher.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Copy and paste the bearer token into the field below",
      items: [
        {
          kind: "input",
          label: "Bearer token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/v3/users?me=true`,
  },
});
